<script>
import {mapGetters, mapState} from "vuex";
import Tile from '@/components/tile.vue';
import planCommon from './mixin';
import { BILLING_CYCLE, BUNDLE_WITH_ZP_BASE_PLAN_TYPES, planTypes } from '@/common/constants';
import base from '@/views/config/addon-cards/templates/base.vue';
import store from '@/store';
import { getPlanLogo } from '@/common/plan-logo-map';
import { hasZoomPhoneFreeTrialPlan } from '@/plans/ZOOM_PHONE/helper/utils';
import { additionalConfigType, AdditionalConfigTypeEnums } from './helper';
import { softBundleForAddon } from '@/views/config/soft-bundle/helper';

export default {
  name: 'ZoomPhoneAdditionalNumber',
  mixins: [base, planCommon],
  components: {
    Tile,
  },
  for:() => {
    // Hide addon if user has Zoom Phone free trial plan
    if (hasZoomPhoneFreeTrialPlan()) {
      return false;
    }
    if (softBundleForAddon[planTypes.ZOOM_PHONE$ADDITIONAL].test?.(store)) return true;
    const hasZoomPhoneWinBack = store.getters.pastPlans.some(plan => [...BUNDLE_WITH_ZP_BASE_PLAN_TYPES, planTypes.ZOOM_PHONE].includes(planTypes[plan.semanticType]));
    if (hasZoomPhoneWinBack) {
      return false;
    }
    const hasProPlus = store.getters.getSelectedPlans.some(plan => planTypes.ZONE_PRO_PLUS === plan.type);
    return additionalConfigType.configType !== AdditionalConfigTypeEnums.NONE && hasProPlus;
  },
  data() {
    return {
      logo: getPlanLogo(planTypes.ZOOM_PHONE$ADDITIONAL),
    };
  },

  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      getSelectedPlans: 'getSelectedPlans',
      getUserCurrentSubscriptions: 'getUserCurrentSubscriptions',
    }),
    currentBillingCycle() {
      return BILLING_CYCLE.ANNUAL;
    },
    defaultPlan() {
      return null
    },
  },
  methods: {
    addOn() {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      document.addPlanFromEnterKey = true;
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction(this.title, `${this.title?.toLowerCase()} - add`);
    },
  }
};
</script>
